var React = require('react');

function AttrVers (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("path",{"d":"M75,117c-23.2,0-42-18.8-42-42s18.8-42,42-42s42,18.8,42,42S98.2,117,75,117z M75,39c-19.9,0-36,16.1-36,36s16.1,36,36,36\n\ts36-16.1,36-36S94.9,39,75,39z","key":1}),React.createElement("path",{"d":"M75.5,117C63.1,117,53,106.9,53,94.5S63.1,72,75.5,72C84.6,72,92,64.6,92,55.5S84.6,39,75.5,39v-6C87.9,33,98,43.1,98,55.5\n\tS87.9,78,75.5,78C66.4,78,59,85.4,59,94.5S66.4,111,75.5,111V117z","key":2})]);
}

AttrVers.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 150 150","style":{"enableBackground":"new 0 0 150 150"},"xmlSpace":"preserve"};

module.exports = AttrVers;

AttrVers.default = AttrVers;
